<template>
  <div v-on-clickaway="away" class="relative">
    <a class="text-gray-600 block py-1 pr-1 relative cursor-pointer " ref="btnDropdownRef" v-on:click="toggleDropdown($event)">
       <i :class="notificationsData.filter((e) =>  !e.vue).length>0?'notification-bell':''" class="material-icons">notifications</i><span v-if="notificationsData.filter((e) =>  !e.vue).length>0" class="dot-count vs-avatar--count badgeNumber">{{notificationsData.filter((e) =>  !e.vue).length}}</span>
    </a>
    <div ref="popoverDropdownRef" class="bg-white text-base z-50 float-left mt-2 list-none text-left rounded-md shadow-lg min-w-48" style="width:20rem;" v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }">
      <div class="dropdown-head bg-primary bg-pattern rounded-top">
            <div class="p-3">
                <div class="row align-items-center">
                    <div class="col">
                        <h6 class="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                    </div>
                    <div class="col-auto dropdown-tabs">
                        <span class="badge bg-light-subtle text-gray-800 fs-13"> {{notificationsData.filter((e) =>  !e.vue).length}} Nouvelle</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-2 pt-0 notif-bar"> 
            <template v-for="(notif,ind) in notificationsData">
              <span :class="!notif.vue?'isnewnotif':''" v-html="notif.text"> </span>
            </template>
            <router-link v-if="user.type !== 'Seller'" :to="{ path: `/sourcings`}" class="flex items-center px-4 py-3 border-b hover:bg-gray-100 show-img-imp">
              <img class="h-8 w-8 rounded-full object-cover mx-1" src="https://img.icons8.com/arcade/64/add-bookmark.png" alt="avatar">
              <p class="text-gray-600 text-sm mx-2">
                Sourcing <b>products</b> maintenant disponible
              </p>
            </router-link>
             <a @click="$vm2.open('ModalFormation')" href="#" class="flex items-center px-4 py-3 border-b hover:bg-gray-100">
              <img class="h-8 w-8 rounded-full object-cover mx-1" src="https://img.icons8.com/color/48/youtube-play.png" alt="avatar">
              <div class="media-body flex-grow-1 text-sm mx-2">
                <p class="text-gray-600">Video explicative de l'intégration Google Sheets</p>
                <!-- <p class="notification-time">3 hours ago</p> -->
              </div>
              
            </a>
             <a @click="$vm2.open('ModalFormation')" href="#" class="flex items-center px-4 py-3 border-b hover:bg-gray-100">
              <img class="h-8 w-8 rounded-full object-cover mx-1" src="https://img.icons8.com/color/48/youtube-play.png" alt="avatar">
              <p class="text-gray-600 text-sm mx-2">
                  Video explicative de l'upsell
              </p>
            </a>
            <a href="#" class="flex items-center px-4 py-3 border-b hover:bg-gray-100">
              <img class="h-8 w-8 rounded-full object-cover mx-1" src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/external-upselling-merchandising-flaticons-lineal-color-flat-icons.png" alt="avatar">
              <p class="text-gray-600 text-sm mx-2">
                  <b>Upsell product</b> maintenant disponible
              </p>
            </a>
            <router-link :to="{ path: `/orders/api#sheet`}" class="flex items-center px-4 py-3  hover:bg-gray-100 show-img-imp">
              <img class="h-8 w-8 rounded-full object-cover mx-1" src="https://img.icons8.com/color/96/google-sheets.png" alt="avatar">
              <p class="text-gray-600 text-sm mx-2">
                  Integration <b>google sheet</b> maintenant disponible
              </p>
            </router-link>
            
            
          </div> 
      <!-- <a href="#" class="block bg-gray-800 text-white text-center font-bold py-2">See all notifications</a> -->
    </div>
  </div>
</template>
<script>
import { createPopper } from "@popperjs/core";
import { mixin as clickaway } from "vue-clickaway";
export default {
  mixins: [clickaway],
  props: {
      user: { type: Object},
      notifications: { type: Array,default: () => []},
  },
  data() {
    return {
      dropdownPopoverShow: false,
      notificationsData:this.notifications
    };
  },
  watch: {
    'notifications': function (newVal, oldVal) {
        // console.log('notifications changed------',this.notifications)
        // console.log("new", newVal);
        // console.log("old", oldVal);
        this.notificationsData=this.notifications;
    },
  }, 
  async mounted() {
    console.log('mounted notifications-----',this.notificationsData)
  },
  methods: {
    toggleDropdown: async function (event) {
      
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {placement: "bottom-start",});
       if(['Seller','sourcing'].includes(this.user.type) && this.notificationsData.filter((e) =>  !e.vue).length>0){
           console.log('update default notifications-----',this.notifications)
           const data = await this.$server.update("users", {_id:this.user._id,Notification:'default'});
           console.log('data  notifications-----',data)
           if(data && data._id){
            var now = new Date().getTime();
            while(new Date().getTime() < now + 1000){ 
                /* Do nothing */ 
            }
              this.notificationsData=data.notifications.filter((e) => e.type === 'default').reverse();
              this.$store.dispatch("actionSeller",{user:data}); 
              this.$store.dispatch("actionupdate",{update_version:'ok',NewNotifs:0,OldNotifs:0});
           } 
       } 
      }
    },
    toggle() {
      this.dropdownPopoverShow = !this.dropdownPopoverShow;
    },
    away() {
      this.dropdownPopoverShow = false;
    },
  },
};
</script>
<style scoped>

.notif-bar{
  height: 100%;
  max-height: 300px;
  overflow: auto;
}
.align-items-center {
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}
.row {
  --vz-gutter-x: 1.5rem;
  --vz-gutter-y: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 2px;
  margin-right:  2px;
  margin-left:  2px;
}
.row > * {
  position: relative;
}
.col {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 0%;
  flex: 1 0 0%;
  height: 35px;
}
.row > * {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right:  2px;
  padding-left:  2px;
  margin-top:  2px;
}
.fs-16 {
  font-size: 16px !important;
}
.col-auto {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  width: auto;
}
.bg-pattern {
  background-color: #6590e5 !important;
}
.rounded-top {
  border-top-left-radius: 0.25em !important;
  border-top-right-radius: 0.25em !important;
}
.badge {
  line-height: .95;
  display: inline-block;
  border-radius:0.25em;
  padding:0.35em 0.65em;
  font-weight:500;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}
.fs-13 {
  font-size: 13px !important;
}
.bg-light-subtle {
  background-color: #f8fafb !important;
}

</style>
